import React from 'react'
import { useMutation } from '@apollo/client'
import { UPDATE_FORM_BUILDER_BY_FORM_STRING_ID } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
import { GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID } from '../../../graphql/query'
import { useParams } from 'react-router-dom'
import { ensureUniqueFormFieldIds } from './tableFieldUtils'
import { normalizeSingleRecipientNameFlag } from './prefillFieldSettingsUtils'

interface Props {
  closeSaveModal: () => void
  formElements: any
  formJson: any
  setFormJson: any
}

const SaveFormBuilder: React.FC<Props> = ({
  closeSaveModal,
  formElements,
  formJson,
  setFormJson
}) => {
  const params = useParams()
  const uuid = params.uuid
  const [SaveFormJson] = useMutation(UPDATE_FORM_BUILDER_BY_FORM_STRING_ID, {
    refetchQueries: [
      {
        query: GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID,
        variables: {
          input: {
            formUuid: uuid
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Form-Builder'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Form-Builder'
      }
    }
  })

  const SaveChanges = async () => {
    try {
      // Persist unique top-level fieldIds so Address/Plain Input never share state after reload.
      const uniqueFormData = ensureUniqueFormFieldIds(
        Array.isArray(formElements?.[0]) ? formElements : [formElements]
      )
      const normalizedFormData = normalizeSingleRecipientNameFlag(uniqueFormData)
      const inputRes = await SaveFormJson({
        variables: {
          input: {
            formUuid: uuid,
            cardStyle: formJson.cardStyle,
            cardBackground: formJson.cardBackground,
            featuresToUpdate: {
              formData: normalizedFormData
            }
          }
        }
      })

      closeSaveModal()
      if (inputRes.data.updateFormBuilderByFormStringId.message) {
        toast.success(inputRes.data.updateFormBuilderByFormStringId.message)
      } else {
        toast.error('Failed to save changes.')
      }
    } catch (err) {
      toast.error('Sorry! Unexpected Error.')
      console.error(err)
    }
  }

  return (
    <div className='card-body'>
      <p className='fs-5 fw-bold'>Are you sure you want to save these changes?</p>

      <div className='d-flex justify-content-end mt-10'>
        <button type='reset' className='btn btn-sm btn-white me-2' onClick={() => closeSaveModal()}>
          Cancel
        </button>

        <button type='submit' className='btn btn-sm btn-primary' onClick={SaveChanges}>
          <span className='indicator-label'>Save</span>
        </button>
      </div>
    </div>
  )
}

export default SaveFormBuilder
